<script setup lang="ts">
  import MainLayout from '../../views/layouts/MainLayout.vue'
  import BoxTitle from '../../components/FreeTourPage/BoxTitle.vue'
  import BoxVideo from '../../components/FreeTourPage/BoxVideo.vue'
  import IconeBds from 'assets/img/icone_BDS.png'
  import BoxArrayImages from '../../components/FreeTourPage/BoxArrayImages.vue'
  import BoxBannerPromotionAndPlans from '../../components/FreeTourPage/BoxBannerPromotionAndPlans.vue'
  import {  onBeforeMount } from 'vue'
  import { useRoute } from 'vue-router'
  import { useHead } from '@unhead/vue'

  const route = useRoute()

  onBeforeMount(() => {
    const lang = ['pt-br', 'en']
    if (!containsElement(lang, route.params.locale)) 
    window.location.replace('/')
  })

  function containsElement(targetArray: string[], element: string | string[]) {
    // Verifica se o elemento é um array
    if (Array.isArray(element)) {
      // Se for um array, verifica se todos os elementos estão no targetArray
      return element.every((item) => targetArray.includes(item))
    } else {
      // Se for uma string, verifica se ela está no targetArray
      return targetArray.includes(element)
    }
  }

  useHead({
    templateParams: {
      subTitle: null,
      subPage: 'Free Tour',
      page_url: window.location.origin + route.fullPath,
      page_description:
        route.params.locale == 'pt-br'
          ? `Descubra o que de melhor o Bella da Semana tem a oferecer...`
          : `Discover the best that Bella Club has to offer ...`,
      page_image: '/favicon.ico',
      page_keywords:
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
      page_locale: route.params.locale == 'pt-br'? 'pt-br':'en',
      page_url_pt: 'https://belladasemana.com.br/pt-br/freetour',
      page_url_en: 'https://belladasemana.com.br/en/freetour',
      page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
  })
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="l-main">
        <div class="row row-header">
          <div class="col-lg-5 col-12 order-lg-1 order-1 col-header">
            <BoxTitle :img="IconeBds" />
          </div>
          <div class="col-lg-7 col-12 order-lg-2 order-2">
            <BoxVideo />
          </div>
          <div class="col-lg-12 col-12 order-lg-3 order-3">
            <div class="block block--gray">
              <div class="container">
                <div class="gallery gallery--narrow">
                  <div class="gallery__list">
                    <BoxArrayImages />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BoxBannerPromotionAndPlans />
      </div>
    </div>
  </MainLayout>
</template>


<style scoped lang="css">
  .slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
  }
  .box-header {
    margin-bottom: -10px;
  }

  @media only screen and (min-width: 752px) {
    #freetour-video-box {
      width: 100%;
      height: 636px;
    }
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    :deep(.col-4) {
      width: 25%;
    }
    :deep(.col-5) {
      width: 40%;
    }
    :deep(.col-2) {
      width: 30%;
    }
    :deep(.list-plans) {
      padding-left: unset !important;
    }
    :deep(hr) {
      margin-top: 5px !important;
      margin-bottom: 5px !important;
    }
  }
</style>
